<template>
  <div class="flex flex-row h-full w-full">
    <TrafficLocationsSidebar @center-path="centerPath" @clear="onClear" />
    <div class="h-full relative flex-1">
      <button
        @click="centerMap"
        class="bg-white shadow rounded-sm absolute z-10 focus:outline-none flex items-center justify-center"
        style="bottom: 116px; right: 10px; width: 40px; height: 40px"
      >
        <i class="material-icons text-gray-60 hover:text-gray-80">
          center_focus_weak
        </i>
      </button>

      <button
        @click="togglePlaces"
        class="bg-white shadow rounded-sm absolute z-10 focus:outline-none flex items-center justify-center"
        style="bottom: 166px; right: 10px; width: 40px; height: 40px"
      >
        <i class="material-icons text-gray-60 hover:text-gray-80">
          {{ showPlaces ? 'location_off' : 'location_on' }}
        </i>
      </button>

      <div ref="map" class="w-full h-full"></div>
    </div>
  </div>
</template>

<script>
import TrafficLocationsSidebar from '@/components/TrafficLocations/TrafficLocationsSidebar'
import GoogleMapService from '@/services/GoogleMapService'
import { get } from 'vuex-pathify'

const options = {
  zoom: 8,
  gestureHandling: 'greedy',
  streetViewControl: false,
  fullscreenControl: false,
  mapTypeControl: false,
  zoomControl: true,
  mapTypeId: 'roadmap'
}

export default {
  name: 'TrafficLocationsMap',

  components: {
    TrafficLocationsSidebar
  },

  data() {
    return {
      showPlaces: true,
      google: null,
      map: null,
      markers: [],
      pathMarkers: [],
      path: null
    }
  },

  watch: {
    routePath: {
      handler(newPath) {
        if (this.path) {
          this.path.setMap(null)
        }

        if (this.pathMarkers.length) {
          this.pathMarkers.forEach(marker => {
            marker.setMap(null)
          })

          this.pathMarkers = []
        }

        if (!newPath.length) return

        this.path = this.createPath(newPath)

        this.path.setMap(this.map)

        newPath.forEach(marker => {
          const place = {
            ...marker,
            lon: marker.lng,
            name: marker.place
          }
          const newMarker = this.createPlace(place)
          newMarker.setMap(this.map)
          this.pathMarkers.push(newMarker)
        })

        this.centerPath()
      }
    },

    places: {
      handler(places) {
        places.forEach(place => {
          const marker = this.createPlace(place)
          marker.setMap(this.map)
          this.markers.push(marker)
        })
      }
    }
  },

  async mounted() {
    this.google = await GoogleMapService.init()
    this.map = await this.createMap()
    await this.$store.dispatch('routeLinks/fetchPlaces')
    this.centerMap()
  },

  computed: {
    routePath: get('routeLinks/routePath'),
    places: get('routeLinks/places@data')
  },

  methods: {
    createMap() {
      const map = new this.google.maps.Map(this.$refs.map, {
        ...options
      })

      return map
    },

    createPath(path) {
      return new this.google.maps.Polyline({
        path,
        strokeColor: '#3B59FF',
        strokeOpacity: 1,
        strokeWeight: 4
      })
    },

    createPlace(place) {
      return new this.google.maps.Marker({
        position: { lat: place.lat, lng: place.lon },
        title: place.name,
        icon: {
          url: require('@/assets/marker_icon.png'),
          anchor: new this.google.maps.Point(6, 6),
          scaledSize: new this.google.maps.Size(12, 12)
        }
      })
    },

    centerPath() {
      const bounds = new this.google.maps.LatLngBounds()
      this.path.getPath().forEach(path => {
        bounds.extend(path)
      })
      this.map.setCenter(bounds.getCenter())
      this.map.fitBounds(bounds)
    },

    centerMap() {
      const bounds = new this.google.maps.LatLngBounds()
      this.markers.forEach(marker => {
        bounds.extend(marker.getPosition())
      })
      this.map.setCenter(bounds.getCenter())
      this.map.fitBounds(bounds)
    },

    togglePlaces() {
      this.showPlaces = !this.showPlaces

      this.markers.forEach(marker => {
        if (this.showPlaces) {
          marker.setMap(this.map)
        } else {
          marker.setMap(null)
        }
      })
    },

    onClear() {
      this.pathMarkers.forEach(marker => {
        marker.setMap(null)
      })
      this.pathMarkers = []
      this.path.setMap(null)
      this.path = null

      this.centerMap()
    }
  }
}
</script>
